<template>
  <div class="pages" v-if="page_show">
    <div class="bg_wrap">
      <img class="bg_gif" src="https://static.zhenhuixuan365.com/employ/bg.gif" />
    </div>
    <div class="main">
      <img class="bg_gif" src="https://static.zhenhuixuan365.com/employ/main.jpg" />
      <img class="hangmu" src="https://static.zhenhuixuan365.com/employ/hangmu4.png" />
    </div>
    <div class="front">
      <img class="logo" src="https://static.zhenhuixuan365.com/employ/logo.png" />
      <img class="title" src="https://static.zhenhuixuan365.com/employ/title.png" />
      <div class="btns">
        <button class="clickBtn"
          @click="onClick({ name: 'employ.position.list', query: { position_type: '校园招聘' } })"><span></span><span></span><span></span><span></span>
          校园招聘</button>
        <button class="clickBtn"
          @click="onClick({ name: 'employ.position.list', query: { position_type: '实习生招聘' } })"><span></span><span></span><span></span><span></span>
          实习生招聘</button>
        <button class="clickBtn"
          @click="onClick({ name: 'employ.company' })"><span></span><span></span><span></span><span></span>
          公司介绍</button>
        <button class="clickBtn"
          @click="onClick({ name: 'employ.position.list', query: { position_type: '内部推荐' } })"><span></span><span></span><span></span><span></span>
          内部推荐</button>
        <button class="clickBtn"
          @click="onClick({ name: 'employ.position.list', query: { position_type: '社会招聘' } })"><span></span><span></span><span></span><span></span>
          社会招聘</button>

      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      page_show: false
    }
  },
  mounted() {
    document.title = '中船航海人才招聘'
    this.loadData()
  },
  methods: {
    loadData() {
      let that = this
      this.$api.ucenterInfo({}).then(res => {
        that.page_show = true
      })
    },
    onClick(obj) {
      setTimeout(() => {
        this.$router.push(obj)
      }, 500)
    }
  }
}
</script>

<style scoped src="./index.css"></style>
    